let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gLCed")).then(() => parcelRequire('9vOS7'));